export default __webpack_public_path__ + "static/media/lackier_start.9f1e3784.png";